import { render, staticRenderFns } from "./addTypeWorkLeave.vue?vue&type=template&id=9f2f8ad6&scoped=true&"
import script from "./addTypeWorkLeave.vue?vue&type=script&lang=js&"
export * from "./addTypeWorkLeave.vue?vue&type=script&lang=js&"
import style0 from "./addTypeWorkLeave.vue?vue&type=style&index=0&id=9f2f8ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2f8ad6",
  null
  
)

export default component.exports